module.exports = __webpack_public_path__ + "assets/aac893948d54c30212a3075d4eab80a3.mp3";